import { Box, FieldSet, FillPreview, Slider, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React from 'react';
import { colorsInSessionAtom } from '../../../../../atoms/session-atoms';
import { BiCtaNames } from '../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { ColorSliderCopyIcon } from './color-slider-copy-icon';
import { ColorSliderRevertIcon } from './color-slider-revert-icon';
const COLOR_PICKER_MODAL_HEIGHT = 420;
const COLOR_PICKER_OFFSET = 65;
const ctaNamesMapping = {
  background: {
    close: BiCtaNames.BackgroundColorPickerClose,
    copy: BiCtaNames.BackgroundColorCopy,
    open: BiCtaNames.BackgroundOpenColorPicker,
    revert: BiCtaNames.BackgroundColorRevert,
    slider: BiCtaNames.BackgroundOpenColorSlider
  },
  foreground: {
    close: BiCtaNames.ForegroundColorPickerClose,
    copy: BiCtaNames.ForegroundColorCopy,
    open: BiCtaNames.ForegroundOpenColorPicker,
    revert: BiCtaNames.ForegroundColorRevert,
    slider: BiCtaNames.ForegroundOpenColorSlider
  }
};
export const ColorSlider = _ref => {
  let {
    label,
    colorState,
    maxScale,
    colorPickerAriaLabel,
    sliderType,
    status,
    index,
    isGeneric,
    currentContrastRatioLevel
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    lightness,
    hex,
    onLightnessChange,
    setColor
  } = colorState;
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const colorsInSession = useAtomValue(colorsInSessionAtom);
  const ctaNamesBySliderType = ctaNamesMapping[sliderType];
  const handleFillPreviewOnClick = event => {
    biLogger.taskElementCtaClick({
      ctaName: ctaNamesBySliderType.open,
      index,
      status: status ? isGeneric ? ElementStatus.ManualPassed : ElementStatus.Passed : isGeneric ? ElementStatus.ManualFailed : ElementStatus.Failed
    });
    a11yWizardAdapter.openColorPicker({
      customInstanceColors: colorsInSession,
      left: event.clientX,
      onChange: setColor,
      onClose: () => biLogger.taskElementCtaClick({
        ctaName: ctaNamesBySliderType.close,
        index,
        status: status ? isGeneric ? ElementStatus.ManualPassed : ElementStatus.Passed : isGeneric ? ElementStatus.ManualFailed : ElementStatus.Failed
      }),
      top: event.screenY > -COLOR_PICKER_MODAL_HEIGHT ? event.clientY - COLOR_PICKER_MODAL_HEIGHT - COLOR_PICKER_OFFSET : event.clientY - COLOR_PICKER_OFFSET,
      value: hex
    });
  };
  return /*#__PURE__*/React.createElement(FieldSet, {
    alignment: "center",
    columns: isGeneric ? '24px auto min-content' : '28px auto min-content',
    gap: "medium",
    legend: label,
    legendPlacement: "top",
    legendSize: "small",
    maxLines: 2,
    ellipsis: true
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: t('accessibility-wizard.rules-list.color-contrast.color-slider.color-preview.tooltip', {
      color: hex
    }),
    size: "small"
  }, /*#__PURE__*/React.createElement(FillPreview, {
    "aria-label": colorPickerAriaLabel,
    aspectRatio: 1,
    fill: hex,
    onClick: handleFillPreviewOnClick
  })), /*#__PURE__*/React.createElement(Slider, {
    displayMarks: false,
    displayTooltip: false,
    max: maxScale,
    min: 0,
    value: lightness,
    onBlur: () => biLogger.taskElementCtaClick({
      ctaName: ctaNamesBySliderType.slider,
      index,
      status: status ? isGeneric ? ElementStatus.ManualPassed : ElementStatus.Passed : isGeneric ? ElementStatus.ManualFailed : ElementStatus.Failed
    }),
    onChange: value => onLightnessChange(value)
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    gap: isGeneric ? '3px' : undefined
  }, /*#__PURE__*/React.createElement(ColorSliderRevertIcon, {
    colorState: colorState,
    ctaName: ctaNamesBySliderType.revert,
    index: index,
    isGeneric: isGeneric,
    status: status
  }), isGeneric && /*#__PURE__*/React.createElement(ColorSliderCopyIcon, {
    colorState: colorState,
    ctaName: ctaNamesBySliderType.copy,
    currentContrastRatioLevel: currentContrastRatioLevel,
    index: index,
    status: status
  })));
};
//# sourceMappingURL=color-slider.js.map